"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetUserSelfResponse = exports.ApiCredentials = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
const ApiCredential = zod_1.z.object({
    userId: common_1.Uuid,
    clientId: zod_1.z.string(),
    clientSecretLastFour: zod_1.z.string().length(4),
    createdAt: common_1.SerializableDate,
});
exports.ApiCredentials = zod_1.z.array(ApiCredential);
const WorkspaceMembership = zod_1.z.object({
    id: common_1.Uuid,
    name: zod_1.z.string(),
});
exports.GetUserSelfResponse = zod_1.z.object({
    name: zod_1.z.string(),
    avatar: zod_1.z.string().nullable(),
    id: common_1.Uuid,
    workspaces: zod_1.z.array(WorkspaceMembership),
});
